// Header behaviour that the mockup got for free and a storefront does not.
//
// Two jobs:
//   1. The phone burger opens the department panel, which lives in a different
//      section. Sections cannot reach into each other, so this asks on the document
//      and aps-nav answers.
//   2. The account flyout opens on click as well as hover. Hover alone is a desktop
//      pointer assumption: on a phone there is no hover at all, and on a keyboard
//      there is no way in.
const MOBILE = '(max-width: 767px)';

class ApsHeader extends HTMLElement {
  connectedCallback() {
    this.burger = this.querySelector('[data-aps-open-panel]');
    this.acct = this.querySelector('.acct');
    this.toggle = this.querySelector('[data-aps-acct-toggle]');
    this.scrim = this.querySelector('[data-aps-acct-scrim]');
    this.closeBtn = this.querySelector('[data-aps-acct-close]');

    this.close = this.close.bind(this);
    this.onDocClick = this.onDocClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.burger?.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('aps:panel-open', { detail: { trigger: this.burger } }));
    });

    if (!this.toggle || !this.acct) return;
    this.toggle.addEventListener('click', () => {
      this.acct.classList.contains('open') ? this.close() : this.open();
    });
    this.closeBtn?.addEventListener('click', this.close);
    this.scrim?.addEventListener('click', this.close);
    document.addEventListener('click', this.onDocClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocClick);
    document.removeEventListener('keydown', this.onKeydown);
  }

  get isDrawer() {
    return window.matchMedia(MOBILE).matches;
  }

  open() {
    this.acct.classList.add('open');
    this.toggle.setAttribute('aria-expanded', 'true');
    if (this.isDrawer) {
      // Only the drawer covers the page, so only the drawer locks the page behind
      // it. The desktop flyout is a popover -- locking scroll there would freeze the
      // page for a hover.
      document.body.style.overflow = 'hidden';
      this.acct.querySelector('.fly a, .fly button')?.focus();
    }
  }

  close() {
    if (!this.acct.classList.contains('open')) return;
    this.acct.classList.remove('open');
    this.toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    // Always the trigger. Restoring whatever was focused before sends focus to
    // <body> whenever the drawer was opened by anything but a mouse.
    if (this.isDrawer) this.toggle.focus();
  }

  onDocClick(e) {
    if (!this.acct.classList.contains('open')) return;
    if (this.acct.contains(e.target) && !this.scrim?.contains(e.target)) return;
    this.close();
  }

  onKeydown(e) {
    if (e.key !== 'Escape') return;
    this.close();
  }
}
customElements.define('aps-header', ApsHeader);
